/* product-specs.js — injects up to 4 factual detail rows into product cards store-wide.
   Facts are precomputed offline (deterministic extraction, never invented) and shipped as
   product-facts.json (dict-encoded: {v:[strings], p:{handle:[idx,...]}}). This script only
   looks up by product handle (from the card link href) and renders — no parsing/guessing here.
   Wine cards (data-wine-title) are skipped; the separate wine-specs engine owns those. */
(function () {
  if (window.__psxInit) return; window.__psxInit = 1;

  var DATA = null, PENDING = [];
  var FACTS_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? '' : '') + document.currentScript && document.currentScript.dataset
    ? document.currentScript.dataset.src : null;

  // icon per fact kind (kept generic; matched by leading label)
  function icon(label) {
    var l = label.toLowerCase(), p;
    if (/^\d/.test(label) && /(г|кг|мл|л|бр|×)/i.test(label)) p = 'M3 7h18v13H3zM3 7l3-4h12l3 4'; // package
    else if (l.indexOf('произведено') === 0 || l.indexOf('итал') >= 0) p = 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20M2 12h20M12 2c3 3 3 17 0 20M12 2c-3 3-3 17 0 20'; // globe
    else if (l.indexOf('kcal') >= 0 || l.indexOf('протеин') === 0 || l.indexOf('мазнини') === 0 || l.indexOf('захари') === 0 || l.indexOf('фибри') === 0) p = 'M4 3h16v4H4zM6 7v14h12V7'; // nutrition/box
    else if (l.indexOf('без') === 0 || l.indexOf('веган') >= 0 || l.indexOf('био') === 0 || l.indexOf('msc') >= 0 || l.indexOf('dop') >= 0 || l.indexOf('igp') >= 0) p = 'M20 6L9 17l-5-5'; // check
    else if (l.indexOf('аромат') === 0) p = 'M12 2s6 5 6 11a6 6 0 0 1-12 0c0-6 6-11 6-11'; // droplet
    else if (l.indexOf('арабика') >= 0 || l.indexOf('робуста') >= 0 || l.indexOf('печене') >= 0) p = 'M4 8h13v5a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5zM17 9h2a2 2 0 0 1 0 4h-2'; // coffee cup
    else if (l.indexOf('пранета') >= 0 || l.indexOf('дози') >= 0) p = 'M12 3a9 9 0 1 0 9 9 M12 3v4M12 7a5 5 0 1 1-5 5'; // wash
    else if (l.indexOf('алкохол') >= 0 || l.indexOf('сервиране') >= 0) p = 'M8 3h8l-1 7a3 3 0 0 1-6 0zM12 10v8M8 21h8'; // glass
    else p = 'M9 11l3 3L22 4M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11'; // generic check-box
    return '<span class="psi"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' +
      p.split('M').filter(Boolean).map(function (s) { return '<path d="M' + s.trim() + '"/>'; }).join('') +
      '</svg></span>';
  }

  function handleOf(card) {
    var a = card.querySelector('a.st-card-lk[href], a.st-card-textlk[href]');
    if (!a) return null;
    var href = a.getAttribute('href') || '';
    try { href = decodeURIComponent(href); } catch (e) {}
    var m = href.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function render(card, facts) {
    if (card.getAttribute('data-psx-done')) return;
    card.setAttribute('data-psx-done', '1');
    if (!facts || !facts.length) return;
    var body = card.querySelector('.st-card-body');
    var foot = card.querySelector('.st-card-foot');
    if (!body || !foot) return;
    var box = document.createElement('div');
    box.className = 'psx';
    box.innerHTML = facts.slice(0, 4).map(function (f) {
      return '<span class="ps">' + icon(f) + '<span class="psl">' + f + '</span></span>';
    }).join('');
    foot.parentNode.insertBefore(box, foot); // sits above price/CTA
  }

  function scan(root) {
    var cards = (root || document).querySelectorAll('.st-card:not([data-psx-done])');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.hasAttribute('data-wine-title')) { card.setAttribute('data-psx-done', '1'); continue; } // wine engine owns these
      if (!DATA) { PENDING.push(card); continue; }
      var h = handleOf(card);
      var ids = h && DATA.p[h];
      if (ids) render(card, ids.map(function (k) { return DATA.v[k]; }));
      else card.setAttribute('data-psx-done', '1');
    }
  }

  function boot(json) {
    DATA = json;
    var q = PENDING; PENDING = [];
    for (var i = 0; i < q.length; i++) { q[i].removeAttribute('data-psx-done'); }
    scan(document);
  }

  function start() {
    scan(document); // queue cards while data loads
    var script = document.getElementById('product-specs-js') || document.currentScript;
    var url = (script && script.dataset && script.dataset.src) || FACTS_URL;
    if (!url) return;
    fetch(url, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(boot).catch(function () {});
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { scan(document); break; }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
